import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "mateaventura.token";
const MODE_KEY = "mateaventura.mode"; // "cloud" | "guest"

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export function getMode() {
  return localStorage.getItem(MODE_KEY);
}

export function setMode(mode) {
  if (mode) localStorage.setItem(MODE_KEY, mode);
  else localStorage.removeItem(MODE_KEY);
}

function authHeader() {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export function extractErrorMsg(err) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (d?.msg) return d.msg;
  return err?.message || "Algo salió mal. Intenta de nuevo.";
}

export async function apiRegister({ username, password, nombre, apellido, email, profile }) {
  const { data } = await axios.post(`${API}/auth/register`, {
    username,
    password,
    nombre,
    apellido,
    email,
    profile,
  });
  setToken(data.token);
  setMode("cloud");
  return data;
}

export async function apiLogin(username, password) {
  const { data } = await axios.post(`${API}/auth/login`, { username, password });
  setToken(data.token);
  setMode("cloud");
  return data;
}

export async function apiMe() {
  const { data } = await axios.get(`${API}/me`, { headers: authHeader() });
  return data;
}

export async function apiSyncProfile(profile) {
  if (!getToken()) return null;
  const { data } = await axios.put(
    `${API}/me/profile`,
    { profile },
    { headers: authHeader() }
  );
  return data;
}

export function logout() {
  setToken(null);
  setMode(null);
}
